import { FC } from 'react';
import { APP_VERSION } from '@Constants/runtimeConstants';
import { UserText } from '@Constants/UserText';
import { LegalLinks } from './LegalLinks';
import { StatusIndicatorDot } from '@Components/StatusIndicatorDot';

interface ILegalLinksAndVersionProps {
    isBackendConnected?: boolean;
}

export const LegalLinksAndVersion: FC<ILegalLinksAndVersionProps> = ({ isBackendConnected }) => {
    const connectedStatus = isBackendConnected ? 'success' : 'error';
    const connectedStatusText = isBackendConnected ? 'Verbunden' : 'Nicht verbunden';

    const versionString = `${UserText.APP_NAME} v${APP_VERSION}`;

    return (
        <div className="flex flex-col gap-1">
            <div className="flex justify-center">
                <div className="text-xs text-(--mantine-color-text-3) flex gap-1">
                    <StatusIndicatorDot status={connectedStatus} statusText={connectedStatusText} />
                    <span>{versionString}</span>
                </div>
            </div>
            <LegalLinks />
        </div>
    );
};
